import React from 'react';
import { useSelector } from 'react-redux';

function NavbarLoader() {
  const isLoading = useSelector((state) => state.navbarLoader.get('isLoading'));

  // eslint-disable-next-line react/jsx-no-useless-fragment
  return <>{isLoading && <div className="navbar-loader" />}</>;
}

export default NavbarLoader;
